"use client";

import { coinbaseWallet } from "@/util/coinbase-wallet";
import { magicConnectorAa } from "@/util/magic-connector-aa";
import { magicConnector } from "@/util/magic-connectors";
import { IS_SERVER } from "@talentir/shared/config";
import { getBlockchainRpc, getChain } from "@talentir/shared/helpers";
import { walletConnect } from "@wagmi/connectors";
import type { JSX } from "react";
import { http } from "viem";
import { arbitrum, base, baseSepolia, sepolia } from "viem/chains";
import { WagmiProvider, createConfig } from "wagmi";

const config = createConfig({
    chains: [getChain(), arbitrum],
    connectors: IS_SERVER
        ? []
        : [
              magicConnector(),
              magicConnectorAa(),
              coinbaseWallet({
                  appName: "Talentir",
                  appLogoUrl: "https://talentir.com/images/talentir-logo-t.png",
                  preference: "smartWalletOnly",
              }),
              walletConnect({
                  projectId: "057f1a355a4f57caa670c39d8dbbc3dd",
              }),
          ].flat(),
    transports: {
        [arbitrum.id]: http(getBlockchainRpc(arbitrum)),
        [sepolia.id]: http(getBlockchainRpc(sepolia)),
        [baseSepolia.id]: http(getBlockchainRpc(baseSepolia)),
        [base.id]: http(getBlockchainRpc(base)),
    },
});

export function TalentirWagmiProvider({ children }: { children: React.ReactNode }): JSX.Element {
    return <WagmiProvider config={config}>{children}</WagmiProvider>;
}
